const proposalAction = {
    CREATE_QUOTE : 'create quote',

    COPY_PROPOSAL : 'copy proposal',

    DELETE_PROPOSAL : 'delete proposal',

    BIND_PROPOSAL : 'bind proposal',

    BIND_PROPOSAL_FROM_SENT : 'bind proposal from sent',

    SEND_PROPOSAL : 'send proposal',

    SEND_BINDER : 'send binder',

    ADD_SECTION : 'add section',

    ADD_DOCUMENT : 'add document',

    DELETE_SECTION : 'delete section',

    BEGIN_BINDING_PROPOSAL : 'begin binding proposal',

    DECLINE_TO_BIND_PROPOSAL : 'decline to bind proposal',

    DECLINE_TO_BIND_PROPOSAL_FROM_SENT : 'decline to bind proposal from sent',

    REQUEST_TO_BIND_PROPOSAL : 'request to bind proposal',

    REQUEST_TO_BIND_PROPOSAL_FROM_SENT : 'request to bind proposal from sent',

    GENERATE_BINDER_PROPOSAL : 'generate binder proposal',

    GENERATE_QUOTES : 'generate quotes',

    MODIFY_PROPOSAL : 'modify proposal'

};

angular.module('gw-um-j2js')
    .constant('proposalAction', proposalAction);